export default __webpack_public_path__ + "static/media/selected.4b71ed9f.svg";